import { Component, Input, Output, EventEmitter } from '@angular/core';

import { ExamGroup } from '../../exam-group/exam-group';
import { ExamTemplate } from '../exam-template';

@Component({
  selector: 'mc-exam-template-form',
  templateUrl: './exam-template-form.component.html'
})
export class ExamTemplateFormComponent {

  @Input() template: ExamTemplate;
  @Input() examGroups: ExamGroup[];
  @Output() canceled: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() saved: EventEmitter<ExamTemplate> = new EventEmitter<ExamTemplate>();

  constructor() {}

  save(): void {
    this.saved.emit(this.template);
  }

  cancel(): void {
    this.canceled.emit(true);
  }
}
